import type { FetchTrackedOneGraphOperation } from "../../apollo/ApolloNativeModule";

import TypedNativeModules from "../internal/TypedNativeModules";

/**
 * True when callers supplied additional OneGraph headers that the legacy
 * `fetchNativeOneGraphOperation` bridge cannot accept (it always sends null headers).
 */
function hasAdditionalOneGraphHeaders(headers?: string): boolean {
  if (headers == null || headers === "") {
    return false;
  }
  try {
    const parsed: unknown = JSON.parse(headers);
    return (
      typeof parsed === "object" &&
      parsed != null &&
      !Array.isArray(parsed) &&
      Object.keys(parsed).length > 0
    );
  } catch {
    // Fail closed: unparseable header payloads must not go through the legacy path.
    return true;
  }
}

const fetchNativeOneGraphOperation: FetchTrackedOneGraphOperation = async (
  queryString: string,
  variablesJSONString: string,
  operationName: string | null,
  headers?: string,
  options?: string,
) => {
  const trackedFetch = TypedNativeModules.RNCoreNativeModule?.fetchTrackedOneGraphOperation;
  if (typeof trackedFetch === "function") {
    return await trackedFetch(queryString, variablesJSONString, operationName, headers, options);
  }

  // Legacy fetchNativeOneGraphOperation has no headers parameter on either platform.
  // Prefer failing closed over silently dropping headers such as indeed-placementid.
  if (hasAdditionalOneGraphHeaders(headers)) {
    throw new Error(
      "fetchTrackedOneGraphOperation is required when OneGraph request headers are provided",
    );
  }

  const coreFetch = TypedNativeModules.RNCoreNativeModule?.fetchNativeOneGraphOperation;
  if (typeof coreFetch === "function") {
    return await coreFetch(queryString, variablesJSONString, operationName, options);
  }

  return {};
};

export default fetchNativeOneGraphOperation;
